module.exports = __webpack_public_path__ + "static/media/tesi_maratona.f31e1095.pdf";